import { createSlice } from "@reduxjs/toolkit"
import { REHYDRATE } from "redux-persist"
export const PageListingSlice = createSlice({
  name: "pageListingSlice",
  initialState: {
    loading: false,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload.loading
    },
  },
  extraReducers: builder => {
    builder.addCase(REHYDRATE, state => {
      if (state.loading) {
        state.loading = state.loading
      }
    })
  },
})

export const { setLoading } = PageListingSlice.actions

export default PageListingSlice.reducer
